import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getHighRiskSupplementWarningTypes } from '@api/highRiskSupplements';
import { IRiskSupplementWarningTypeResponseDTO } from '@interfaces/highRiskSupplements';

export const handleGetHighRiskSupplementWarningTypes = createAsyncThunk<
  AxiosResponse<IRiskSupplementWarningTypeResponseDTO>,
  void
>('getHighRiskSupplementWarningTypes', getHighRiskSupplementWarningTypes);
